function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      height: "100%",
      width: "100%",
      background: "transparent"
    },
    width: "47px",
    height: "47px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.625s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e1e0",
    d: "M55 52.1H45V31.7c0-1.6 1.3-2.9 2.9-2.9h4.2c1.6 0 2.9 1.3 2.9 2.9v20.4z",
    style: {
      fill: "rgb(224, 225, 224)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.694444s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7b26b",
    d: "M56.2 19.8c0 3.4-2.8 6.2-6.2 6.2s-6.2-2.8-6.2-6.2S50 7.7 50 7.7s6.2 8.7 6.2 12.1z",
    style: {
      fill: "rgb(247, 178, 107)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.763889s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e1e0",
    d: "M75 53.6H65V33.2c0-1.6 1.3-2.9 2.9-2.9h4.2c1.6 0 2.9 1.3 2.9 2.9v20.4z",
    style: {
      fill: "rgb(224, 225, 224)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.833333s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7b26b",
    d: "M74.5 22.3c0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5 4.5-8.7 4.5-8.7 4.5 6.2 4.5 8.7z",
    style: {
      fill: "rgb(247, 178, 107)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.902778s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e0e1e0",
    d: "M35 53.6H25V33.2c0-1.6 1.3-2.9 2.9-2.9h4.2c1.6 0 2.9 1.3 2.9 2.9v20.4z",
    style: {
      fill: "rgb(224, 225, 224)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.972222s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7b26b",
    d: "M34.5 22.3c0 2.5-2 4.5-4.5 4.5s-4.5-2-4.5-4.5 4.5-8.7 4.5-8.7 4.5 6.2 4.5 8.7z",
    style: {
      fill: "rgb(247, 178, 107)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.04167s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4e6c8",
    d: "M79 92.3H21c-1.9 0-3.5-1.6-3.5-3.5v-35c0-1.9 1.6-3.5 3.5-3.5h58c1.9 0 3.5 1.6 3.5 3.5v35c0 1.9-1.6 3.5-3.5 3.5z",
    style: {
      fill: "rgb(244, 230, 200)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.11111s infinite normal forwards running cake-breath"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f47e5f",
    d: "M15.7 64.5c0 2 1.6 3.8 3.7 3.8 2 0 3.9-.5 5.6-1.4 1.1-.6 2.4-.6 3.5 0 1.7.9 3.6 1.4 5.6 1.4s3.9-.5 5.6-1.4c1.1-.6 2.4-.6 3.5 0 1.7.9 3.6 1.4 5.6 1.4 2 0 3.9-.5 5.6-1.4 1.1-.6 2.4-.6 3.5 0 1.7.9 3.6 1.4 5.6 1.4s3.9-.5 5.6-1.4c1.1-.6 2.4-.6 3.5 0 1.7.9 3.6 1.4 5.6 1.4 1 0 2-.1 2.9-.4 1.7-.4 2.9-2 2.9-3.7V53.1c0-2.1-1.7-3.8-3.8-3.8H19.5c-2.1 0-3.8 1.7-3.8 3.8v11.4z",
    style: {
      fill: "rgb(244, 126, 95)"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.ce72941a.svg";
export { ForwardRef as ReactComponent };